import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ConfirmEventType, ConfirmationService, MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { Observable, Subscription, tap } from 'rxjs';
import { AppNav, NavCategory } from 'src/app/models/app-nav';
import { PermEditorComponent } from '../perms-editor/perms-editor.component';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { PermsService } from '@/services/api/perms.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-app-nav',
  imports: [CommonModule, TableModule, DialogModule, ButtonModule, ToastModule, FormsModule, ReactiveFormsModule, SelectModule],
  template: `
<div class="flex align-items-center justify-content-between">
    <h2>Nav Menu Items</h2>
    <p-button icon="pi pi-plus" label="New"
        styleClass="p-button-success mr-2 p-button-rounded p-button-text"
        (click)="addNew()">
    </p-button>
</div>
    <p-table class="p-datatable-sm cellTable" [value]="navItems" dataKey="appNavId" editMode="row" styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
            <tr>
            <th class="modName">Icon</th>
            <th class="modCost">Label</th>
            <th class="modVis">Link</th>
            <th class="modVis">Category</th>
            <th class="modButton"></th>
            </tr>
            </ng-template>
        <ng-template pTemplate="body" let-nav let-editing="editing" let-ri="rowIndex">
            <tr [pEditableRow]="nav">

                <td class="engName">
                    
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" class="p-inputtext-sm input-box" [(ngModel)]="nav.icon" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            <i [class]="nav.icon"></i>
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td class="engName">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" class="p-inputtext-sm input-box" [(ngModel)]="nav.label" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{nav.label}}
                        </ng-template>
                    </p-cellEditor>
                    
                </td>
                <td class="engName">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <input pInputText type="text" class="p-inputtext-sm input-box" [(ngModel)]="nav.link" required>
                        </ng-template>
                        <ng-template pTemplate="output">
                            {{nav.link}}
                        </ng-template>
                    </p-cellEditor>
                    
                </td>
                <td class="engName">
                    <p-cellEditor>
                        <ng-template pTemplate="input">
                            <p-select [(ngModel)]="nav.Category" inputId="projectStatus" optionLabel="navCategoryName" optionValue="navCategoryId" [options]="navCats">
                            </p-select>

                        </ng-template>
                        <ng-template pTemplate="output">
                            {{nav.navCategories.navCategoryName}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td class="modButton">
                    <div class="flex align-items-center justify-content-center gap-2">
                        <button *ngIf="!editing" pButton pRipple type="button" icon="pi pi-trash" (click)="confirmDeleteNav(nav)" class="p-button-danger p-button-rounded p-button-text"></button>
                        <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onNavRowEditInit(nav)" class="p-button-rounded p-button-text"></button>
                        
                        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onNavRowEditSave(nav)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
                        <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onNavRowEditCancel(nav, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-dialog #addNavDialog [(visible)]="navDialog" 
  [style]="isLargeScreen ? { width: '50vw', height: '80vh' } : { width: '100vw', height: '100vh' }" 
  [header]="'Add Engineer'"
  [modal]="true"
  styleClass="p-fluid">
  <!-- add nav form here -->
</p-dialog>
  `,
  styles:``
})
export class AppNavComponent implements OnInit {
  @Input() navItems: AppNav[] = [];
  isLargeScreen = false;
  private screenSizeSubscription!: Subscription;
  navCats: NavCategory[] = []
  navDialog = false;
  clonedNavs: { [s: string]: AppNav } = {};
  @Output() refreshNav = new EventEmitter<boolean>();

  constructor(
    private permsService: PermsService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.collectNavCats();
  }

  getSelectedCategory(nav:AppNav) {
    if (this.navCats && this.navCats.length > 0) {
      return this.navCats.find(cat => cat.navCategoryId === nav.appNavId) || null;
    }
    return null;
  }

  collectNavItems() {
    this.refreshNav.emit(true);
  }

  cloneNavItems() {
      let navListIndex: { [appNavId: number]: AppNav } = {};

      this.navItems.forEach(nav => {
        navListIndex[nav.appNavId] = nav;
      });
  }

  collectNavCats() {
    console.log('fetching nav cats');
    this.permsService.getNavCategories().subscribe(data => {
      this.navCats = data;
    });
  }

  onNavRowEditInit(nav: AppNav) {
    this.clonedNavs[nav.appNavId.toString() as string] = { ...nav };
    this.refreshNav.emit(true);
  }


  onNavRowEditSave(nav: AppNav) {
    this.permsService.updateNav(nav.appNavId, nav).subscribe(
      response => {
        // This block will be executed if the update is successful.
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Nav Item updated successfully' });
        console.log(response);
      },
      error => {
        // This block will be executed if the update fails.
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update Nav Item:' + error });
      }
    );
  }

  onNavRowEditCancel(nav: AppNav, index: number) {
    this.navItems[index] = this.clonedNavs[nav.appNavId.toString() as string];
    delete this.clonedNavs[nav.appNavId.toString() as string];
  }

  removeNav(appNavId: number): Observable<any> {
    return this.permsService.deleteNav(appNavId).pipe(
      tap(removedNav => {
        this.collectNavItems()
      })
    );
  }

  addNew() {
    this.navDialog = true;
  }

  confirmDeleteNav(nav: AppNav) {
    const navId = nav.appNavId;
    const navName = nav.label
    this.confirmationService.confirm({
      message: `'Do you want to delete '${navName}'?'`,
      header: 'Delete nav item',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.removeNav(navId).subscribe(
          () => {
            this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Nav Removed' });
          },
          (error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not remove Nav' });
            console.error('Error Deleting Nav:', error);
          }
        );
      },
      reject: (type: ConfirmEventType) => {
        switch (type) {
          case ConfirmEventType.CANCEL:
            // this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'You have cancelled' });
            break;
        }
      }
    });
  }

  ngOnDestroy() {

  }

}
